module.exports = __webpack_public_path__ + "static/media/18import-40.03168a6e.xlsx";